<template>
  <div class="content-v2">
    <section class="honor-section">
      <div class="honor-section-head">
        <span>{{ sectionMeta.enTitle }}</span>
        <h2>{{ sectionMeta.title }}</h2>
      </div>
      <div class="honors-grid-v2">
        <div class="honor-card" v-for="item in displayHonorList" :key="item.id">
          <div class="honor-img" @click="openImagePreview(item)">
            <img :src="item.image" :alt="item.name" />
          </div>
        </div>
      </div>
      <div v-if="!displayHonorList.length" class="empty-state">暂无内容</div>
    </section>
    <div v-if="previewImage" class="image-preview-mask" @click.self="closeImagePreview">
      <button class="image-preview-close" type="button" aria-label="关闭大图" @click="closeImagePreview">×</button>
      <img class="image-preview-img" :src="previewImage" :alt="previewAlt" @click.stop />
    </div>
  </div>
</template>

<script>
import { getHonorList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultHonorImage from '@/assets/images/case1.svg'

export default {
  name: 'AboutHonorsV2',
  data() {
    return {
      honorList: [],
      previewImage: '',
      previewAlt: ''
    }
  },
  created() {
    this.loadHonorList()
  },
  mounted() {
    window.addEventListener('keydown', this.handlePreviewKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handlePreviewKeydown)
    document.body.style.overflow = ''
  },
  watch: {
    activeType() {
      this.closeImagePreview()
      this.loadHonorList()
    }
  },
  computed: {
    activeType() {
      return this.$route.meta.honorType || 'qualification'
    },
    sectionMeta() {
      return this.activeType === 'award'
        ? { title: '荣誉奖项', enTitle: 'HONORS & AWARDS' }
        : { title: '资质体系', enTitle: 'QUALIFICATION SYSTEM' }
    },
    displayHonorList() {
      return this.honorList.filter(item => (item.type || 'qualification') === this.activeType)
    }
  },
  methods: {
    loadHonorList() {
      getHonorList({ pageNum: 1, pageSize: 50, honorType: this.activeType }).then(list => {
        if (!list || !list.length) {
          this.honorList = []
          return
        }
        this.honorList = list.map(item => ({
          id: item.honorId,
          name: item.honorName,
          type: item.honorType || 'qualification',
          image: resolveFileUrl(item.imageUrl, defaultHonorImage),
          issuer: item.issuer || '',
          date: item.honorDate || ''
        }))
      }).catch(() => {
        this.honorList = []
      })
    },
    openImagePreview(item) {
      this.previewImage = item.image
      this.previewAlt = item.name || '荣誉资质图片'
      document.body.style.overflow = 'hidden'
    },
    closeImagePreview() {
      this.previewImage = ''
      this.previewAlt = ''
      document.body.style.overflow = ''
    },
    handlePreviewKeydown(event) {
      if (event.key === 'Escape' && this.previewImage) {
        this.closeImagePreview()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.honor-section + .honor-section {
  margin-top: 58px;
}

.honor-section-head {
  margin-bottom: 24px;

  span {
    color: #2563eb;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 4px;
  }

  h2 {
    margin: 10px 0 0;
    color: #0f172a;
    font-size: 32px;
    font-weight: 800;
  }
}

.honors-grid-v2 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.honor-card {
  padding: 0;
  text-align: center;

  .honor-img {
    width: 100%;
    aspect-ratio: 1 / 1;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: transparent;
    cursor: zoom-in;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: contain;
      object-position: center;
    }
  }
}

.image-preview-mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 42px;
  background: rgba(15, 23, 42, 0.86);
  cursor: zoom-out;
}

.image-preview-img {
  max-width: 92vw;
  max-height: 88vh;
  object-fit: contain;
  box-shadow: 0 20px 70px rgba(0, 0, 0, 0.35);
  cursor: default;
}

.image-preview-close {
  position: fixed;
  top: 22px;
  right: 30px;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 34px;
  line-height: 38px;
  cursor: pointer;
}

@media (max-width: 960px) {
  .honors-grid-v2 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .image-preview-mask {
    padding: 22px;
  }

  .image-preview-close {
    top: 14px;
    right: 16px;
  }
}

.empty-state {
  padding: 48px 0;
  color: #94a3b8;
  text-align: center;
  background: #fff;
  border: 1px dashed #cbd5e1;
}
</style>
